import { h } from 'preact';
import { playerStatic } from '../../../../configuration';
import { BLOCK_RECOMMENDATIONS, USER_BACK_TO_CREDITS, USER_CLICK, USER_REPLAY } from '../../../../types';
import { usePlayerContext, useStyles } from '../../../common/hooks';
import { TEXT_LEVEL_3_FONT_SIZE } from '../../../common/styles';
import { withBreakPoints } from '../../hoc';
import { mapKeyBreakpointToContainer } from '../../utils/tools';
import { LabeledButton } from '../common';
import { PLAYER_BUTTON_ICON_STYLE, PLAYER_BUTTON_STYLE, PLAYER_CONTAINER_STYLE, PLAYER_IMAGE_STYLE, PLAYER_WRAPPER_STYLE, REPLAY_SVG_SIZE } from './styles';

function BabyPlayer({ image, hideVideo }) {
  const player = usePlayerContext();
  const setStyles = useStyles();

  const clickHandler = (e) => {
    e.stopPropagation();
    if (hideVideo) {
      player.restart({ autostart: true });
    } else {
      player.userEvents$.next({ action: BLOCK_RECOMMENDATIONS, source: USER_CLICK });
    }

    player.userEvents$.next({
      action: hideVideo ? USER_REPLAY : USER_BACK_TO_CREDITS, source: USER_CLICK
    });
  };
  const videoPlaceHolder = () => (
    hideVideo
      ? (<div style={{ ...setStyles(PLAYER_IMAGE_STYLE), backgroundImage: `url("${image || playerStatic.defaultBgImg}")` }} />)
      : (<div id="baby-player-container" style={setStyles(PLAYER_CONTAINER_STYLE)} />)
  );

  return (
    <div
      tabIndex={0}
      role="button"
      onKeyDown={() => { }}
      onClick={clickHandler}
      style={setStyles(PLAYER_WRAPPER_STYLE)}
    >
      {videoPlaceHolder()}

      <LabeledButton
        label={hideVideo ? 'Regarder à nouveau' : 'Retourner au générique'}
        icon={hideVideo ? 'rewind' : undefined}
        iconSize={setStyles(REPLAY_SVG_SIZE).width}
        iconCustomStyle={setStyles(PLAYER_BUTTON_ICON_STYLE)}
        onClick={clickHandler}
        customStyle={{ ...setStyles(PLAYER_BUTTON_STYLE), ...setStyles(mapKeyBreakpointToContainer(TEXT_LEVEL_3_FONT_SIZE)) }}
      />
    </div>
  );
}

export default withBreakPoints(BabyPlayer);
